import { render } from "./appMain.vue?vue&type=template&id=cc41b45c&scoped=true"
const script = {}

import "./appMain.vue?vue&type=style&index=0&id=cc41b45c&lang=scss&scoped=true"

import exportComponent from "../../node_modules/_vue-loader@17.4.2@vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-cc41b45c"]])

export default __exports__